export const INACTIVITY_MS = 24 * 60 * 60 * 1000; // 24 hours
export const PLAYER_KEY = 'brio_player_id';
export const ROOM_KEY = 'brio_room_id';
export const LAST_ROLL_KEY = 'brio_last_roll';
export const LAST_ROLL_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours
export const TAB_KEY = 'brio_tab';
export const GM_FLOW_KEY = 'brio_gm_flow';
export const GM_NAME_KEY = 'brio_gm_name';
